<template>
	<v-container fluid class="mb-3 px-3 border-ot">
		<div class="marca-agua">
			<img src="@/assets/rr-plagas.png" height="90px" />
		</div>
		<div class="d-flex block w-100 ">
			<div style="width: 32%; line-height: 1.1">
				<img src="@/assets/rr-plagas.png" style="height: 50px; width: 100%;" />
				<div class="ml-3 text-left" style="font-size: 10px !important; font-weight: 500">
					<SPAN>RR CONTROL DE PLAGAS SPA.</SPAN>
					<br />
					<SPAN>RUT: 76.454.646-6</SPAN>
					<br />
					<SPAN>RES. SAN Nª 15970 26/07/2017</SPAN>
					<br />
					<span>REP. LEG: NICOLÁS ROJAS URÍZAR 15.936.593-K</span>
					<br />
					<span>PASAJE MONTREAL 8435, LA FLORIDA, STGO</span>
					<br />
					<span>SUC. ORTUZAR 963, MELIPILLA.</span>
					<br />
					<span>TELEFONO: 228318060 </span>
				</div>
			</div>
			<div
				style="width: 32%; line-height: 1.1; text-align: center; padding-top: 60px; font-weight: 700"
			>
				<span v-if="order.type == 'rrplagas-certificate'" style="font-size: 25px;"
					>CERTIFICADO</span
				>
				<span v-else style="font-size: 25px;">ORDEN DE TRABAJO</span>
			</div>
			<div style="width: 32%; line-height: 1.1; padding-top: 60px;  ">
				<div class="d-flex block w-100 mb-2 " style="justify-content: flex-end;">
					<div style="width: 100px;" class="pa-1 pr-2 text-right">
						<span style="font-size: 16px;">Nº</span>
					</div>
					<div class="bb bt bl br pa-1" style="width: 100px;">
						{{ order.id }}
					</div>
				</div>
				<div class="d-flex block w-100" style="justify-content: flex-end;">
					<div style="width: 100px;" class="pa-1 pr-2 text-right">
						<span style="font-size: 16px;">FECHA</span>
					</div>
					<div class="bb bt bl br pa-1" style="width: 100px;">
						{{ order.date }}
					</div>
				</div>
			</div>
		</div>
		<div>
			<div style="width: 100%;" class="text-center bb bt br bl mt-2 bg">
				<span
					style="color: white; font-size: 15px; font-weight: 500; line-height: 0.5 !important"
					>IDENTIFICACIÓN DE INMUEBLE TRATADO</span
				>
			</div>
			<div style="width: 100%;" class=" text-left bb br bl  pl-1">
				Nombre o Razón social:
				<span class="ml-2">{{ order.data[0] }}</span>
			</div>
			<div style="width: 100%;" class="d-flex text-left  ">
				<div style="width:60%;" class=" bb br bl pl-1">
					Dirección:
					<span class="ml-2">{{ order.data[1] }}</span>
				</div>
				<div style="width:40%;" class="bb br pl-1">
					Comuna:
					<span class="ml-2">{{ order.data[2] }}</span>
				</div>
			</div>
			<div style="width: 100%;" class="d-flex text-left  ">
				<div style="width:33%;" class="bb br bl pl-1">
					Propietario:
					<span class="ml-2">{{ order.data[3] }}</span>
				</div>
				<div style="width:33%;" class="bb br pl-1">
					Rut:
					<span class="ml-2">{{ order.data[4] }}</span>
				</div>
				<div style="width:34%;" class="bb br pl-1">
					Teléfono:
					<span class="ml-2">{{ order.data[5] }}</span>
				</div>
			</div>
			<div style="width: 100%;" class="d-flex text-left  ">
				<div style="width:33%;" class="bb br bl pl-1">
					Solicitante:
					<span class="ml-2">{{ order.data[6] }}</span>
				</div>
				<div style="width:33%;" class="bb br pl-1">
					Rut:
					<span class="ml-2">{{ order.data[7] }}</span>
				</div>
				<div style="width:34%;" class="bb br pl-1">
					Mail:
					<span class="ml-2">{{ order.data[8] }}</span>
				</div>
			</div>
		</div>
		<div>
			<div style="width: 100%;" class="text-center bb bt br bl mt-2 bg">
				<span
					style="color: white; font-size: 15px; font-weight: 500; line-height: 0.5 !important"
					>DESRATIZACION</span
				>
			</div>
			<div style="width: 100%;" class="d-flex text-center  ">
				<div style="width:20%;" class="bb br bl pl-1">
					TIPO ROEDOR
				</div>
				<div style="width:40%;" class="bb br pl-1">
					PRODUCTO UTILIZADO 1
				</div>
				<div style="width:40%;" class="bb br pl-1">
					PRODUCTO UTILIZADO 2
				</div>
			</div>
			<div style="width: 100%; height: 195px" class="d-flex text-center  ">
				<div style="width:20%;" class="bb br bl pt-2">
					Especie
					<div class="d-flex text-left pl-1 ">
						<div
							v-if="order.data[30]"
							style="width: 25px"
							class="bb bt br bl mr-1"
							:class="{ bg: order.data[30] != 'No' }"
						></div>
						<div style="width:80%;">
							<span style="font-size: 10px;">Rattus norvegicus</span>
						</div>
					</div>
					<div class="d-flex text-left pl-1">
						<span
							style="width: 25px"
							:class="{ bg: order.data[31] != 'No' }"
							v-if="order.data[31]"
							class=" br bl mr-1"
						></span>
						<div style="width:80%;">
							<span style=" font-size: 10px;">Rattus rattus</span>
						</div>
					</div>
					<div class="d-flex text-left pl-1">
						<span
							style="width: 25px"
							:class="{ bg: order.data[32] != 'No' }"
							v-if="order.data[32]"
							class="bb bt br bl mr-1"
						></span>
						<div style="width:80%;">
							<span style="font-size: 10px;">Mus musculus</span>
						</div>
					</div>
					<div style="width:100%; color: white;" class="bb bt bg mt-2">
						REVISION
					</div>
					<div class="d-flex justify-end">
						<div style="width:20%;" class="text-center">
							<span style="font-size: 10px;">TOT</span>
						</div>
						<div style="width:20%;" class="text-center">
							<span style="font-size: 10px;">REV</span>
						</div>
						<div style="width:20%;" class="text-center">
							<span style="font-size: 10px;">ACT</span>
						</div>
					</div>
					<div class="d-flex ">
						<div style="width:60%;" class="text-left pl-1">
							<span style="font-size: 10px;">ESTACIONES</span>
						</div>
						<span style="width:20%;" v-if="order.data[33]" class="bb bt br bl mr-1">
							{{ order.data[33] }}</span
						>
						<span style="width:20%;" v-if="order.data[34]" class="bb bt br bl mr-1">
							{{ order.data[34] }}</span
						>
						<span style="width:20%;" v-if="order.data[35]" class="bb bt br bl mr-1">
							{{ order.data[35] }}</span
						>
					</div>
					<div class="d-flex ">
						<div style="width:60%;" class="text-left pl-1">
							<span style=" font-size: 10px;">TRAMPAS</span>
						</div>
						<span style="width:20%;" v-if="order.data[36]" class=" br bl mr-1">
							{{ order.data[36] }}</span
						>
						<span style="width:20%;" v-if="order.data[37]" class=" br bl mr-1">
							{{ order.data[37] }}</span
						>
						<span style="width:20%;" v-if="order.data[38]" class=" br bl mr-1">
							{{ order.data[38] }}</span
						>
					</div>
					<div class="d-flex ">
						<div style="width:60%;" class="text-left pl-1">
							<span style="font-size: 10px;">CAPTURA</span>
						</div>
						<span style="width:20%;" v-if="order.data[39]" class="bb bt br bl mr-1">
							{{ order.data[39] }}</span
						>
						<span style="width:20%;" v-if="order.data[40]" class="bb bt br bl mr-1">
							{{ order.data[40] }}</span
						>
						<span style="width:20%;" v-if="order.data[41]" class="bb bt br bl mr-1">
							{{ order.data[41] }}</span
						>
					</div>
				</div>
				<div style="width:40%;" class="bb br pt-1 text-left">
					<div class="d-flex bb">
						<div style="width:150px;" class="text-left">
							<span style="font-size: 10px;" class="pl-1">PRODUCTO</span>
						</div>
						<span>{{ order.data[20][0].producto }}</span>
					</div>
					<div class="d-flex bb">
						<div style="width:150px;" class="text-left">
							<span style="font-size: 10px;" class="pl-1">REGISTRO ISP</span>
						</div>
						<span>{{ order.data[20][0].isp }}</span>
					</div>
					<div class="d-flex bb">
						<div style="width:150px;" class="text-left">
							<span style="font-size: 10px;" class="pl-1">INGREDIENTE ACTIVO</span>
						</div>
						<span>{{ order.data[20][0].ingredienteActivo }}</span>
					</div>
					<div class="d-flex bb">
						<div style="width:150px;" class="text-left">
							<span style="font-size: 10px;" class="pl-1">FORMULACIÓN</span>
						</div>
						<span>{{ order.data[20][0].formulacion }}</span>
					</div>
					<div class="d-flex bb">
						<div style="width:150px;" class="text-left">
							<span style="font-size: 10px;" class="pl-1">DOSIS</span>
						</div>
						<span>{{ order.data[20][0].dosis }}</span>
					</div>
					<div class="d-flex bb">
						<div style="width:150px;" class="text-left">
							<span style="font-size: 10px;" class="pl-1">CONCENTRACION</span>
						</div>
						<span>{{ order.data[20][0].concentracion }}</span>
					</div>
					<div class="d-flex bb">
						<div style="width:150px;" class="text-left">
							<span style="font-size: 10px;" class="pl-1">NÚMERO DE CEBOS</span>
						</div>
						<span>{{ order.data[20][0].numeroCebos }}</span>
					</div>
					<div class="d-flex bb">
						<div style="width:150px;" class="text-left">
							<span style="font-size: 10px;" class="pl-1">PESO DE CEBOS</span>
						</div>
						<span>{{ order.data[20][0].pesoCebo }}</span>
					</div>
					<div class="d-flex bb">
						<div style="width:150px;" class="text-left">
							<span style="font-size: 10px;" class="pl-1">ANTIDOTO</span>
						</div>
						<span>{{ order.data[20][0].antidoto }}</span>
					</div>
				</div>
				<div style="width:40%;" class="bb br pt-1 text-left">
					<div class="d-flex bb">
						<div style="width:150px;" class="text-left">
							<span style="font-size: 10px;" class="pl-1">PRODUCTO</span>
						</div>
						<span>{{ order.data[20][1].producto }}</span>
					</div>
					<div class="d-flex bb">
						<div style="width:150px;" class="text-left">
							<span style="font-size: 10px;" class="pl-1">REGISTRO ISP</span>
						</div>
						<span>{{ order.data[20][1].isp }}</span>
					</div>
					<div class="d-flex bb">
						<div style="width:150px;" class="text-left">
							<span style="font-size: 10px;" class="pl-1">INGREDIENTE ACTIVO</span>
						</div>
						<span>{{ order.data[20][1].ingredienteActivo }}</span>
					</div>
					<div class="d-flex bb">
						<div style="width:150px;" class="text-left">
							<span style="font-size: 10px;" class="pl-1">FORMULACIÓN</span>
						</div>
						<span>{{ order.data[20][1].formulacion }}</span>
					</div>
					<div class="d-flex bb">
						<div style="width:150px;" class="text-left">
							<span style="font-size: 10px;" class="pl-1">DOSIS</span>
						</div>
						<span>{{ order.data[20][1].dosis }}</span>
					</div>
					<div class="d-flex bb">
						<div style="width:150px;" class="text-left">
							<span style="font-size: 10px;" class="pl-1">CONCENTRACION</span>
						</div>
						<span>{{ order.data[20][1].concentracion }}</span>
					</div>
					<div class="d-flex bb">
						<div style="width:150px;" class="text-left">
							<span style="font-size: 10px;" class="pl-1">NÚMERO DE CEBOS</span>
						</div>
						<span>{{ order.data[20][1].numeroCebos }}</span>
					</div>
					<div class="d-flex bb">
						<div style="width:150px;" class="text-left">
							<span style="font-size: 10px;" class="pl-1">PESO DE CEBOS</span>
						</div>
						<span>{{ order.data[20][1].pesoCebo }}</span>
					</div>
					<div class="d-flex bb">
						<div style="width:150px;" class="text-left">
							<span style="font-size: 10px;" class="pl-1">ANTIDOTO</span>
						</div>
						<span>{{ order.data[20][1].antidoto }}</span>
					</div>
				</div>
			</div>
			<div>
				<div style="width: 100%;" class="text-center bb bt br bl mt-2 bg">
					<span
						style="color: white; font-size: 15px; font-weight: 500; line-height: 0.5 !important"
						>DESINSECTACIÓN</span
					>
				</div>
				<div style="width: 100%;" class="d-flex text-center  ">
					<div style="width:22%;" class="bb br bl pl-1">
						TIPO DE INSECTO
					</div>
					<div style="width:40%;" class="bb br pl-1">
						PRODUCTO UTILIZADO 1
					</div>
					<div style="width:40%;" class="bb br pl-1">
						PRODUCTO UTILIZADO 2
					</div>
				</div>
				<div style="width: 100%; height: 220px" class="d-flex text-center  ">
					<div style="width:22%;" class=" bb br bl  pt-2">
						<div class="d-flex ml-1">
							<div style="width:50%;" class="text-left mr-2">
								<span style="font-size: 9px;">NOMBRE COMUN</span>
							</div>
							<div style="width:50%;" class="text-left ">
								<span style="font-size: 9px;">NOMBRE CIENTIFICO</span>
							</div>
						</div>
						<div class="d-flex text-left pl-1">
							<span style="width:50%; font-size: 8px;">{{ order.data[42] }}</span>
							<span style="width:50%; font-size: 8px;">{{ order.data[43] }}</span>
						</div>
						<div class="d-flex text-left pl-1">
							<span style="width:50%; font-size: 8px;">{{ order.data[44] }}</span>
							<span style="width:50%; font-size: 8px;">{{ order.data[45] }}</span>
						</div>
						<div class="d-flex text-left pl-1">
							<span style="width:50%; font-size: 8px;">{{ order.data[46] }}</span>
							<span style="width:50%; font-size: 8px;">{{ order.data[47] }}</span>
						</div>
						<div style="width:100%; color: white;" class="bb bt bg mt-1">
							METODO
						</div>
						<div class="d-flex mt-1 ml-1">
							<span
								style="width:25px;"
								v-if="order.data[48]"
								class="bb bt br bl mr-1"
								:class="{ bg: order.data[48] != 'No' }"
							></span>
							<div style="width:80%;" class="text-left">
								<span style="font-size: 10px;">PULV. MANUAL</span>
							</div>
						</div>
						<div class="d-flex ml-1">
							<span
								style="width:25px;"
								v-if="order.data[49]"
								class=" br bl mr-1"
								:class="{ bg: order.data[49] != 'No' }"
							></span>
							<div style="width:80%;" class="text-left">
								<span style="font-size: 10px;">ULV</span>
							</div>
						</div>
						<div class="d-flex ml-1">
							<span
								style="width:25px;"
								v-if="order.data[50]"
								class="bb bt br bl mr-1"
								:class="{ bg: order.data[50] != 'No' }"
							></span>
							<div style="width:80%;" class="text-left">
								<span style="font-size: 10px;">JERINGA</span>
							</div>
						</div>
					</div>
					<div style="width:40%;" class="bb br pt-1 text-left">
						<div class="d-flex bb">
							<div style="width:150px;" class="text-left">
								<span style="font-size: 10px;" class="pl-1">PRODUCTO</span>
							</div>
							<span>{{ order.data[20][2].producto }}</span>
						</div>
						<div class="d-flex bb">
							<div style="width:150px;" class="text-left">
								<span style="font-size: 10px;" class="pl-1"
									>INGREDIENTE ACTIVO</span
								>
							</div>
							<span>{{ order.data[20][2].ingredienteActivo }}</span>
						</div>
						<div class="d-flex bb">
							<div style="width:150px;" class="text-left">
								<span style="font-size: 10px;" class="pl-1">FORMULACIÓN</span>
							</div>
							<span>{{ order.data[20][2].formulacion }}</span>
						</div>
						<div class="d-flex bb">
							<div style="width:150px;" class="text-left">
								<span style="font-size: 10px;" class="pl-1"
									>TIPO DE INSECTICIDA</span
								>
							</div>
							<span>{{ order.data[20][2].tipo }}</span>
						</div>
						<div class="d-flex bb">
							<div style="width:150px;" class="text-left">
								<span style="font-size: 10px;" class="pl-1">DOSIS</span>
							</div>
							<span>{{ order.data[20][2].dosis }}</span>
						</div>
						<div class="d-flex bb">
							<div style="width:150px;" class="text-left">
								<span style="font-size: 10px;" class="pl-1">CONCENTRACION</span>
							</div>
							<span>{{ order.data[20][2].concentracion }}</span>
						</div>
						<div class="d-flex bb">
							<div style="width:150px;" class="text-left">
								<span style="font-size: 10px;" class="pl-1">REGISTRO ISP</span>
							</div>
							<span>{{ order.data[20][2].isp }}</span>
						</div>
						<div class="d-flex bb">
							<div style="width:150px;" class="text-left">
								<span style="font-size: 10px;" class="pl-1">ANTIDOTO</span>
							</div>
							<span>{{ order.data[20][2].antidoto }}</span>
						</div>
						<div class="d-flex bb">
							<div style="width:150px;" class="text-left">
								<span style="font-size: 10px;" class="pl-1"
									>CANTIDAD UTILIZADA</span
								>
							</div>
							<span>{{ order.data[20][2].cantidadAplicada }}</span>
						</div>
					</div>
					<div style="width:40%;" class="bb br  pt-1">
						<div class="d-flex bb">
							<div style="width:150px;" class="text-left">
								<span style="font-size: 10px;" class="pl-1">PRODUCTO</span>
							</div>
							<span>{{ order.data[20][3].producto }}</span>
						</div>
						<div class="d-flex bb">
							<div style="width:150px;" class="text-left">
								<span style="font-size: 10px;" class="pl-1"
									>INGREDIENTE ACTIVO</span
								>
							</div>
							<span>{{ order.data[20][3].ingredienteActivo }}</span>
						</div>
						<div class="d-flex bb">
							<div style="width:150px;" class="text-left">
								<span style="font-size: 10px;" class="pl-1">FORMULACIÓN</span>
							</div>
							<span>{{ order.data[20][3].formulacion }}</span>
						</div>
						<div class="d-flex bb">
							<div style="width:150px;" class="text-left">
								<span style="font-size: 10px;" class="pl-1"
									>TIPO DE INSECTICIDA</span
								>
							</div>
							<span>{{ order.data[20][3].tipo }}</span>
						</div>
						<div class="d-flex bb">
							<div style="width:150px;" class="text-left">
								<span style="font-size: 10px;" class="pl-1">DOSIS</span>
							</div>
							<span>{{ order.data[20][3].dosis }}</span>
						</div>
						<div class="d-flex bb">
							<div style="width:150px;" class="text-left">
								<span style="font-size: 10px;" class="pl-1">CONCENTRACION</span>
							</div>
							<span>{{ order.data[20][3].concentracion }}</span>
						</div>
						<div class="d-flex bb">
							<div style="width:150px;" class="text-left">
								<span style="font-size: 10px;" class="pl-1">REGISTRO ISP</span>
							</div>
							<span>{{ order.data[20][3].isp }}</span>
						</div>
						<div class="d-flex bb">
							<div style="width:150px;" class="text-left">
								<span style="font-size: 10px;" class="pl-1">ANTIDOTO</span>
							</div>
							<span>{{ order.data[20][3].antidoto }}</span>
						</div>
						<div class="d-flex bb">
							<div style="width:150px;" class="text-left">
								<span style="font-size: 10px;" class="pl-1"
									>CANTIDAD UTILIZADA</span
								>
							</div>
							<span>{{ order.data[20][3].cantidadAplicada }}</span>
						</div>
					</div>
				</div>
			</div>
			<div>
				<div style="width: 100%; " class="d-flex  bt br bl mt-2 bg text-center  ">
					<div style="width:40%;" class="bb br pl-1">
						<span
							style="color: white; font-size: 15px; font-weight: 500; line-height: 0.5 !important"
						>
							SANITIZACIÓN
						</span>
					</div>

					<div style="width:60%;" class="bb br pl-1">
						<span
							style="color: white; font-size: 15px; font-weight: 500; line-height: 0.5 !important"
						>
							RECOMENDACIONES Y OBSERVACIONES
						</span>
					</div>
				</div>
				<div style="width: 100%; height: 230px" class="bl d-flex text-center  ">
					<div style="width:40%;" class="bb br pt-1 text-left">
						<div class="d-flex bb">
							<div style="width:150px;" class="text-left">
								<span style="font-size: 10px;" class="pl-1">PRODUCTO</span>
							</div>
							<span>{{ order.data[20][4].producto }}</span>
						</div>
						<div class="d-flex bb ">
							<div style="width:150px;" class="text-left">
								<span style="font-size: 10px;" class="pl-1"
									>INGREDIENTE ACTIVO</span
								>
							</div>
							<span>{{ order.data[20][4].ingredienteActivo }}</span>
						</div>
						<div class="d-flex bb ">
							<div style="width:150px;" class="text-left">
								<span style="font-size: 10px;" class="pl-1">FORMULACION</span>
							</div>
							<span>{{ order.data[20][4].formulacion }}</span>
						</div>
						<div class="d-flex bb ">
							<div style="width:150px;" class="text-left">
								<span style="font-size: 10px;" class="pl-1">DOSIS</span>
							</div>
							<span>{{ order.data[20][4].dosis }}</span>
						</div>
						<div class="d-flex bb ">
							<div style="width:150px;" class="text-left">
								<span style="font-size: 10px;" class="pl-1">REGISTRO ISP</span>
							</div>
							<span>{{ order.data[20][4].isp }}</span>
						</div>
						<div class="d-flex bb ">
							<div style="width:150px;" class="text-left">
								<span style="font-size: 10px;" class="pl-1">CANTIDAD APLICADA</span>
							</div>
							<span>{{ order.data[20][4].cantidadAplicada }}</span>
						</div>
					</div>
					<div style="width:60%;" class="bb br  pt-2">
						<div class="d-flex bb mt-2">
							<span class="pl-1">
								Recomendaciones
							</span>
						</div>
						<div
							class="d-flex bb"
							v-for="(item, i) in getRecomendaciones(order.data[21].type)"
							:key="`recomendaciones ${i}`"
						>
							<span class="pl-1">{{ item }}</span>
						</div>
						<div class="d-flex bb mt-2">
							<span class="pl-1">
								{{ order.data[21].data[0] }}
							</span>
						</div>
						<div class="d-flex bb mt-2">
							<span class="pl-1">
								Observaciones
							</span>
						</div>
						<div
							class="d-flex bb"
							v-for="(item, i) in getObservaciones(order.data[21].type)"
							:key="`observaciones ${i}`"
						>
							<span class="pl-1">{{ item }}</span>
						</div>

						<div class="d-flex bb">
							<span class="pl-1">
								{{ order.data[21].data[1] }}
							</span>
						</div>
					</div>
				</div>
			</div>
			<div>
				<div style="width: 100%; " class="d-flex  bt br bl mt-2 bg text-center  ">
					<div style="width:30%;" class="bb br  pl-1">
						<span
							style="color: white; font-size: 15px; font-weight: 500; line-height: 0.5 !important"
						>
							LUGARES DE APLICACION
						</span>
					</div>
					<div style="width:35%;" class="bb br pl-1">
						<span
							style="color: white; font-size: 15px; font-weight: 500; line-height: 0.5 !important"
						>
							TIPO DE VISITA Y SERVICIO
						</span>
					</div>

					<div style="width:35%;" class="bb br pl-1">
						<span
							style="color: white; font-size: 15px; font-weight: 500; line-height: 0.5 !important"
						>
						</span>
					</div>
				</div>
				<div style="width: 100%; height: 250px" class="d-flex text-center  ">
					<div style="width:30%;" class=" bb br bl pl-1 pt-2">
						<div class="d-flex ">
							<div style="width:200px;" class="text-left">
								<span style="font-size: 10px;"></span>
							</div>
							<div style="width:45px;" class="text-left	 ">
								<span style="font-size: 10px;">ROED</span>
							</div>
							<div style="width:45px;" class="text-left pl-1 ">
								<span style="font-size: 10px;">INSEC</span>
							</div>
							<div style="width:45px;" class="text-left pl-1 ">
								<span style="font-size: 10px;">SANIT</span>
							</div>
						</div>
						<div class="d-flex">
							<div style="width:200px;" class="text-left">
								<span style="font-size: 10px;">INTERIOR</span>
							</div>
							<span
								style="width:45px;"
								class="bb bt br bl mr-1"
								:class="{ bg: order.data[51] != 'No' }"
							></span>
							<span
								style="width:45px;"
								class="bb bt br bl mr-1"
								:class="{ bg: order.data[52] != 'No' }"
							></span>
							<span
								style="width:45px;"
								class="bb bt br bl mr-1"
								:class="{ bg: order.data[53] != 'No' }"
							></span>
						</div>
						<div class="d-flex">
							<div style="width:200px;" class="text-left">
								<span style="font-size: 10px;">EXTERIOR</span>
							</div>
							<span
								style="width:45px;"
								class=" bb br bl mr-1"
								:class="{ bg: order.data[54] != 'No' }"
							></span>
							<span
								style="width:45px;"
								class=" bb br bl mr-1"
								:class="{ bg: order.data[55] != 'No' }"
							></span>
							<span
								style="width:45px;"
								class=" bb br bl mr-1"
								:class="{ bg: order.data[56] != 'No' }"
							></span>
						</div>
						<div class="d-flex">
							<div style="width:200px;" class="text-left">
								<span style="font-size: 10px;">CASINO/COCINA</span>
							</div>
							<span
								style="width:45px;"
								class=" bb br bl mr-1"
								:class="{ bg: order.data[57] != 'No' }"
							></span>
							<span
								style="width:45px;"
								class=" bb br bl mr-1"
								:class="{ bg: order.data[58] != 'No' }"
							></span>
							<span
								style="width:45px;"
								class=" bb br bl mr-1"
								:class="{ bg: order.data[59] != 'No' }"
							></span>
						</div>
						<div class="d-flex">
							<div style="width:200px;" class="text-left">
								<span style="font-size: 10px;">OFICINAS</span>
							</div>
							<span
								style="width:45px;"
								class=" bb br bl mr-1"
								:class="{ bg: order.data[60] != 'No' }"
							></span>
							<span
								style="width:45px;"
								class=" bb br bl mr-1"
								:class="{ bg: order.data[61] != 'No' }"
							></span>
							<span
								style="width:45px;"
								class=" bb br bl mr-1"
								:class="{ bg: order.data[62] != 'No' }"
							></span>
						</div>
						<div class="d-flex">
							<div style="width:200px;" class="text-left">
								<span style="font-size: 10px;">BAÑOS/CAMARIN</span>
							</div>
							<span
								style="width:45px;"
								class=" bb br bl mr-1"
								:class="{ bg: order.data[63] != 'No' }"
							></span>
							<span
								style="width:45px;"
								class=" bb br bl mr-1"
								:class="{ bg: order.data[64] != 'No' }"
							></span>
							<span
								style="width:45px;"
								class=" bb br bl mr-1"
								:class="{ bg: order.data[65] != 'No' }"
							></span>
						</div>
						<div class="d-flex">
							<div style="width:200px;" class="text-left">
								<span style="font-size: 10px;">ESTANQUES</span>
							</div>
							<span
								style="width:45px;"
								class=" bb br bl mr-1"
								:class="{ bg: order.data[66] != 'No' }"
							></span>
							<span
								style="width:45px;"
								class=" bb br bl mr-1"
								:class="{ bg: order.data[67] != 'No' }"
							></span>
							<span
								style="width:45px;"
								class=" bb br bl mr-1"
								:class="{ bg: order.data[68] != 'No' }"
							></span>
						</div>
						<div class="d-flex">
							<div style="width:200px;" class="text-left">
								<span style="font-size: 10px;">BODEGAS</span>
							</div>
							<span
								style="width:45px;"
								class=" bb br bl mr-1"
								:class="{ bg: order.data[69] != 'No' }"
							></span>
							<span
								style="width:45px;"
								class=" bb br bl mr-1"
								:class="{ bg: order.data[70] != 'No' }"
							></span>
							<span
								style="width:45px;"
								class=" bb br bl mr-1"
								:class="{ bg: order.data[71] != 'No' }"
							></span>
						</div>
						<div class="d-flex">
							<div style="width:200px;" class="text-left">
								<span style="font-size: 10px;">SALA DE VENTAS</span>
							</div>
							<span
								style="width:45px;"
								class=" bb br bl mr-1"
								:class="{ bg: order.data[72] != 'No' }"
							></span>
							<span
								style="width:45px;"
								class=" bb br bl mr-1"
								:class="{ bg: order.data[73] != 'No' }"
							></span>
							<span
								style="width:45px;"
								class=" bb br bl mr-1"
								:class="{ bg: order.data[74] != 'No' }"
							></span>
						</div>
						<div class="d-flex">
							<div style="width:200px;" class="text-left">
								<span
									style="width:200px; font-size: 10px;"
									class="text-left text-uppercase"
									>{{ order.data[87] }}</span
								>
							</div>

							<span
								style="width:45px;"
								class=" bb br bl mr-1"
								:class="{ bg: order.data[75] != 'No' }"
							></span>
							<span
								style="width:45px;"
								class=" bb br bl mr-1"
								:class="{ bg: order.data[76] != 'No' }"
							></span>
							<span
								style="width:45px;"
								class=" bb br bl mr-1"
								:class="{ bg: order.data[77] != 'No' }"
							></span>
						</div>
						<div class="d-flex">
							<div style="width:200px;" class="text-left">
								<span
									style="width:200px; font-size: 10px;"
									class="text-left text-uppercase"
									>{{ order.data[88] }}</span
								>
							</div>

							<span
								style="width:45px;"
								class=" bb br bl mr-1"
								:class="{ bg: order.data[78] != 'No' }"
							></span>
							<span
								style="width:45px;"
								class=" bb br bl mr-1"
								:class="{ bg: order.data[79] != 'No' }"
							></span>
							<span
								style="width:45px;"
								class=" bb br bl mr-1"
								:class="{ bg: order.data[80] != 'No' }"
							></span>
						</div>
					</div>
					<div style="width:35%;" class="bb br pl-1 pt-2">
						<div class="d-flex">
							<span
								style="width:45px;"
								class="bt bb br bl mr-1"
								:class="{ bg: order.data[81] != 'No' }"
							></span>
							<div style="width:200px;" class="text-left">
								<span style="font-size: 10px;">INICIAL</span>
							</div>
						</div>
						<div class="d-flex">
							<span
								style="width:45px;"
								class=" bb br bl mr-1"
								:class="{ bg: order.data[82] != 'No' }"
							></span>
							<div style="width:200px;" class="text-left">
								<span style="font-size: 10px;">MANTENCION</span>
							</div>
						</div>
						<div class="d-flex">
							<span
								style="width:45px;"
								class=" bb br bl mr-1"
								:class="{ bg: order.data[83] != 'No' }"
							></span>
							<div style="width:200px;" class="text-left">
								<span style="font-size: 10px;">EXTRA</span>
							</div>
						</div>
						<div class="d-flex">
							<span
								style="width:45px;"
								class=" bb br bl mr-1"
								:class="{ bg: order.data[84] != 'No' }"
							></span>
							<div style="width:200px;" class="text-left">
								<span style="font-size: 10px;">MONITOREO</span>
							</div>
						</div>
						<div class="d-flex">
							<span
								style="width:45px;"
								class=" bb br bl mr-1"
								:class="{ bg: order.data[85] != 'No' }"
							></span>
							<div style="width:200px;" class="text-left">
								<span style="font-size: 10px;">CONTROL DE PLAGA</span>
							</div>
						</div>
						<div class="d-flex">
							<span
								style="width:45px;"
								class=" bb br bl mr-1"
								:class="{ bg: order.data[86] != 'No' }"
							></span>
							<div style="width:200px;" class="text-left">
								<span style="font-size: 10px;">DIAGNOSTICO</span>
							</div>
						</div>
						<div class="d-flex mt-2">
							<div style="width:200px;" class="text-left ml-2">
								<span style="font-size: 12px;">INICIO TRATAMIENTO</span>
							</div>
							<div class="">
								<span style="width:25%" class="text-left">{{ order.start }}</span>
							</div>
						</div>
						<div class="d-flex ">
							<div style="width:200px;" class="text-left ml-2">
								<span style="font-size: 12px;">TERMINO TRATAMIENTO</span>
							</div>
							<div class="">
								<span style="width:25%" class="text-left">{{ order.end }}</span>
							</div>
						</div>
						<div class="d-flex">
							<div style="width:200px;" class="text-left ml-2">
								<span style="font-size: 12px;">VIGENCIA TRATAMIENTO</span>
							</div>
							<div class="">
								<span style="width:25%" class="text-left"
									>{{ order.vigencia ? order.vigencia : 'Dias no definidos' }}
								</span>
							</div>
						</div>
						<div class="d-flex mt-2">
							<div style="width:200px;" class="text-left ml-2">
								<span style="font-size: 12px;">HORA INICIO TRATAMIENTO</span>
							</div>
							<div class="">
								<span style="width:25%" class="text-left">{{
									order.startHour
								}}</span>
							</div>
						</div>
						<div class="d-flex ">
							<div style="width:200px;" class="text-left ml-2">
								<span style="font-size: 12px;">HORA TERMINO TRATAMIENTO</span>
							</div>
							<div class="">
								<span style="width:25%" class="text-left">{{ order.endHour }}</span>
							</div>
						</div>
					</div>
					<div style="width:35%;" class="bb br pl-1 pt-2">
						<div class="d-flex my-1 bb bt bl br mx-1 px-1 py-1">
							<span style="font-size: 12px;" class="text-left"
								><b>RR CONTROL DE PLAGAS</b> NO SE HACE RESPONSABLE POR POSIBLES
								RE-INFESTACIONES A FALTA DE CONDICIONES BASICAS DE SANEAMIENTO Y/O
								AL INCUMPLIMIENTO DE LAS RECOMENDACIONES TECNICAS
							</span>
						</div>
						<div class="d-flex bb bt bl br mx-1 px-1 py-1">
							<span style="font-size: 12px;" class="text-left"
								><b>RR CONTROL DE PLAGAS</b> NO REALIZARA NINGUN TIPO DE LABOR
								CUANDO SE ENCUENTREN PRESENTES PERSONAS AJENAS A LA EMPRESA, A MENOS
								QUE CUENTEN CON TODOS SUS IMPLEMENTOS DE PROTECCION PERSONAL
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="d-flex justify-center mt-1" style="font-size: 10px !important;">
			<div class="mx-2">
				<img
					contain
					:src="order.firma"
					alt=""
					class="firma-cliente firmas"
					style="border-bottom: 1px solid black; max-height: 110px; height; 110px !important"
				/>

				<div v-if="order.cliente">
					<br />
					Firma OT Cliente
					<br />{{ order.cliente.nombre }}<br />
					{{ order.cliente.rut }}
				</div>
			</div>
			<div class="mx-2">
				<img
					contain
					src="@/assets/firma-nicolas.png"
					alt=""
					class="firma-cliente firmas"
					style="border-bottom: 1px solid black; max-height: 110px; height; 110px !important"
				/>
				<br />
				Representante técnico
				<br />Nicolas Rojas<br />
				15.936.593- k
			</div>
			<div class="mx-2" v-if="order.tecnico === '60ff353887dc12000a28adba'">
				<img
					contain
					src="@/assets/firma-daniel.png"
					alt=""
					class="firma-cliente firmas"
					style="border-bottom: 1px solid black; max-height: 110px; height; 110px !important"
				/>
				<br />
				Técnico aplicador
				<br />Daniel Urizar<br />
			</div>
			<div class="mx-2" v-if="order.tecnico === '613a20c30da29d000bd15afd'">
				<img
					contain
					src="@/assets/firma-harry.png"
					alt=""
					class="firma-cliente firmas"
					style="border-bottom: 1px solid black; max-height: 110px; height; 110px !important"
				/>
				<br />
				Técnico aplicador
				<br />Harry Rojas<br />
				5.787.230-6
			</div>
			<div class="mx-2" v-if="order.tecnico === '6136ae41907daa000a31ad88'">
				<img
					contain
					src="@/assets/firma-nicolas.png"
					alt=""
					class="firma-cliente firmas"
					style="border-bottom: 1px solid black; max-height: 110px; height; 110px !important"
				/>
				<br />
				Técnico aplicador
				<br />Nicolas Rojas<br />
				15.936.593-k
			</div>
		</div>
		<v-row class="antecedentes-fotograficos">
			<template v-if="images.length">
				<v-col cols="12">
					Antecedentes fotográficos:
				</v-col>
				<div v-for="(img, key) in images" :key="key" class="d-flex child-flex ">
					<a :href="img.url" target="_blank">
						<v-img
							lazy-src="@/assets/placeholder.png"
							:src="img.url"
							max-height="200px"
							max-width="200px"
							class="mr-1 mb-1"
							style="border-radius: 15px;"
							alt="imagen de la orden"
						>
							<div class="bg caption text-right">
								{{ createAt(img._id) }}
							</div>
						</v-img>
					</a>
				</div>
			</template>
		</v-row>
	</v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import recomendationsRrplagas from '../../assets/rrplagas/recomendationsRrplagas.json';
import moment from 'moment';

export default {
	props: {
		workOrder: {
			type: Array,
			required: false,
		},
	},
	data() {
		return {
			indexWorkOrder: undefined,
			place: '',
			images: [],
			order: {
				date: undefined,
				data: [''],
				id: undefined,
				user: undefined,
				correo: undefined,
				imagen: { date: undefined, image: undefined },
				type: 'rrplagas',
				firma: '',
				start: '',
				end: '',
			},
			recomendationsRrplagas,
		};
	},
	computed: {
		dateTime() {
			return moment(this.order[79]).format('lll');
		},
		...mapGetters({
			lodgingSelect: 'Lodging/lodgingSelect',
		}),
	},
	watch: {
		workOrder() {
			this.order = this.workOrder;
		},
	},
	created() {
		document.getElementById('viewport').setAttribute('content', 'width=1400');
		this.idLodging = this.$route.params.idLodging;
		this.indexWorkOrder = this.$route.params.index;
		if (this.workOrder) {
			this.order.data = this.formatWorkOrder(this.workOrder.data);
			this.place = this.lodgingSelect.place;
			if (this.lodgingSelect.documents) {
				const documents = this.lodgingSelect.documents;
				this.images = documents.filter(document => {
					const typeDocument = document.url.slice(-3);
					if (this.validateImage(typeDocument)) return true;
					return false;
				});
			}
		} else if (this.idLodging && this.indexWorkOrder)
			this.getWorkOrder({
				idLodging: this.idLodging,
				indexWorkOrder: this.indexWorkOrder,
			}).then(data => {
				this.order = data.workOrder;
				this.order.data = this.formatWorkOrder(data.workOrder.data);
				this.place = data.place;
				this.images = data.documents.filter(document => {
					const typeDocument = document.url.slice(-3);
					if (this.validateImage(typeDocument)) return true;
					return false;
				});
			});
	},
	methods: {
		getObservaciones(observationType) {
			if (observationType) {
				if (this.order.data[21].customObservaciones.length)
					return this.order.data[21].customObservaciones;
				else return this.recomendationsRrplagas[observationType].observaciones;
			}
		},
		getRecomendaciones(observationType) {
			if (observationType) {
				if (this.order.data[21].customRecomendaciones.length)
					return this.order.data[21].customRecomendaciones;
				else return this.recomendationsRrplagas[observationType].observaciones;
			}
			if (observationType)
				return this.recomendationsRrplagas[observationType].recomendaciones;
		},
		isToday(orderDate, datePhoto) {
			return moment(orderDate).isSame(datePhoto, 'day');
		},
		createAt(date) {
			if (date) return moment(date).format('lll');
			else return 'Sin fecha';
		},
		hasInfo(item) {
			return item !== 'Sin info';
		},
		validateImage(typeDocument) {
			typeDocument = typeDocument.toLowerCase();
			if (typeDocument === 'jpg' || typeDocument === 'png' || typeDocument === 'peg')
				return true;
			return false;
		},
		formatWorkOrder(workOrder) {
			return workOrder.map(item => {
				if (item === null || item === false) return 'No';
				if (item === true) return 'Si';
				else return item;
			});
		},
		...mapActions({
			getWorkOrder: 'Lodging/getWorkOrder',
		}),
	},
};
</script>

<style scoped>
input {
	height: 18px;
	border: 1px solid gray;
	background-color: #a2850721;
}

.nw {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.marca-agua {
	position: absolute;
	top: 40%;
	left: 30%;
	opacity: 0.1;
	z-index: 1;
}
* {
	color: black;
	-webkit-print-color-adjust: exact !important;
	color-adjust: exact !important;
}
/* Tamaño pagina 1056 1392 px  */
@media print {
	@page {
		size: A3 portrait;
		width: 100%;
		margin: auto;
	}
	.firmas {
		max-height: 90px !important;
		height: 90px !important;
	}
	.antecedentes-fotograficos {
		display: none;
	}
	.border-ot {
		display: table;
		margin: 0 auto;
		border: 0px !important;
	}
}
.border-a {
	border-bottom: 2px solid gray !important ;
	margin-bottom: 2px;
	width: 98%;
	max-width: 1050px;
	height: 1300px;
}
.bl {
	border-left: 1px solid black;
}
.br {
	border-right: 1px solid black;
}
.bt {
	border-top: 1px solid black;
}
.bb {
	border-bottom: 1px solid black;
}
.bg {
	background-color: #c02030;
}
.bg-secondary {
	background-color: #a5c01352;
}
.cc {
	width: 30px;
	height: 15px;
}

.border-ot {
	background-color: white;
	margin: 5px auto;
	width: 100%;
	max-width: 1050px;
}
.foto-antecedentes {
	border-radius: 15px;
	margin-bottom: 50px;
	height: 200px;
	width: 200px;
	border: 1px solid black;
}
</style>
